import React from "react";

export function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6 wf-fade-up">
      <div>
        {eyebrow && <div className="eyebrow mb-1">{eyebrow}</div>}
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#F7F5F0]">{title}</h1>
        {subtitle && <p className="text-[#8A97AC] text-sm mt-1.5 max-w-xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, body, action }) {
  return (
    <div className="wf-card rounded-2xl p-10 text-center flex flex-col items-center gap-3">
      {Icon && <Icon className="w-10 h-10 text-[#E5C378]/60" />}
      <h3 className="font-display text-lg font-semibold text-[#F7F5F0]">{title}</h3>
      <p className="text-sm text-[#8A97AC] max-w-sm">{body}</p>
      {action}
      <p className="text-[10px] text-[#6E7D97] italic mt-2">"At the right time, I, the LORD, will make it happen."</p>
    </div>
  );
}

const STATUS_STYLES = {
  confirmed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  available: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  pending: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  maybe: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  declined: "bg-rose-500/15 text-rose-300 border-rose-500/40",
  unavailable: "bg-rose-500/15 text-rose-300 border-rose-500/40",
  draft: "bg-white/8 text-gray-300 border-white/15",
  preparing: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  ready: "bg-sky-500/15 text-sky-300 border-sky-500/40",
  published: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  completed: "bg-white/8 text-gray-400 border-white/15",
};

export function StatusBadge({ status, className = "" }) {
  const cls = STATUS_STYLES[status] || "bg-white/8 text-gray-300 border-white/15";
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold border capitalize ${cls} ${className}`}>
      {status}
    </span>
  );
}

export function KeyBadge({ children }) {
  return <span className="px-2.5 py-1 rounded-md text-xs font-mono font-bold bg-[#E5C378]/15 text-[#E5C378] border border-[#E5C378]/30">{children}</span>;
}
export function BpmBadge({ children }) {
  return <span className="px-2.5 py-1 rounded-md text-xs font-mono bg-sky-500/15 text-sky-300 border border-sky-500/30">{children}</span>;
}
export function MetaBadge({ children }) {
  return <span className="px-2 py-1 rounded-md text-xs font-mono bg-white/5 text-gray-300 border border-white/10">{children}</span>;
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-xs font-medium text-[#B8C1D1] mb-1.5 block">{label}</span>
      {children}
    </label>
  );
}

export const inputCls =
  "w-full bg-[#0B101D] border border-white/10 rounded-xl px-3 py-2 text-sm text-[#F7F5F0] placeholder:text-[#6E7D97] focus:outline-none focus:border-[#E5C378]/40";
